import type { NextPage } from 'next'
import dayjs from "dayjs";
import Tooltip from "@/components/tooltip";

interface IProps {
  datetime?: string | number;
  format?: 'dateTime' | 'relative' | 'date' | 'dateDot' | 'time' | string | undefined;
  useTooltip?: boolean
  className?: string | undefined;
}

const DayjsComponent: NextPage<IProps> = ({ format, className='', useTooltip, datetime, children }) => {
  if (children === null || children === undefined || children === '' || children === 0) {
    return (<span className={className}>-</span>);
  }
  const inputDateTime = children as string || datetime;
  // const d = dayjs(inputDateTime).add(9, 'hour');
  const d = dayjs(inputDateTime);
  let standardDateTime = d.format('YYYY-MM-DD HH:mm:ss');

  const relativeFormat = (d: dayjs.Dayjs) => {
    const now = dayjs();
    const format = (dayjs(now.format('YYYY-MM-DD')).isSame(d.format('YYYY-MM-DD')))
      ? '오늘, HH:mm:ss'
      : 'YYYY-MM-DD'
    return format
  }

  let convFormat = '';
  if (format) {
    if (format === 'relative') {
      convFormat = relativeFormat(d)
    } else if (format === 'dateTime') {
      convFormat = 'YYYY-MM-DD HH:mm:ss'
    } else if (format === 'date') {
      convFormat = 'YYYY-MM-DD'
    } else if (format === 'dateDot') {
      convFormat = 'YYYY.MM.DD'
    } else if (format === 'time') {
      convFormat = 'HH:mm:ss'
    } else {
      convFormat = format
    }
  } else {
    convFormat = relativeFormat(d)
  }

  const dc = d.format(convFormat)

  return (
    useTooltip
      ? <Tooltip message={standardDateTime}><time className={className} dateTime={standardDateTime}>{dc}</time></Tooltip>
      : <time className={className} dateTime={standardDateTime}>{dc}</time>
  )
}

export default DayjsComponent
